/**
 * Product mockup used in the hero and the pricing card.
 * The rendered mockup lives in Drive (Producto - DPS35 / mockup /
 * "DPS35 - Principal - Court Ready.png"). Upload it here and paste the URL.
 * While this is empty, a code-drawn stack of the six volumes is shown instead.
 */
export const PRODUCT_MOCKUP =
  'https://cdn.magicpatterns.com/uploads/abLzNtc5eMNGDdvAoeAbfX/Photorealistic-premium-product-mockup-of.png'

/** Where every buy button sends the coach (confirmed ImpulTienda checkout). */
export const CHECKOUT_URL = 'https://court-ready.impultienda.ar/checkout'

export const PRODUCT_MOCKUP_ALT =
  'Court Ready: six volumes of ready-to-run pickleball Session Cards — Day-One Ready, The Beginner Install, The Intermediate Install, Game & Situation Sessions, Clinic Ready and Season Ready — plus five bonuses'

export const VOLUMES = [
  { number: '01', title: 'Day-One Ready', accent: 'bg-court-teal' },
  { number: '02', title: 'The Beginner Install', accent: 'bg-court-blue' },
  { number: '03', title: 'The Intermediate Install', accent: 'bg-[#1E4E80]' },
  { number: '04', title: 'Game & Situation Sessions', accent: 'bg-court-coral' },
  { number: '05', title: 'Clinic Ready', accent: 'bg-court-lime' },
  { number: '06', title: 'Season Ready', accent: 'bg-court-teal' },
]
